import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H3, LI, P, UL } from "../../../AbstractElements";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Receive, Transfer, YourCurrentBalances } from "../../../Constant";

const YourCurrentBalance = () => {
  return (
    <Col xl="3" md="6" sm="12" className="box-col-4e">
      <Card>
        <CommonCardHeader title={YourCurrentBalances} className="card-no-border" />
        <CardBody className="pt-0">
          <UL className="list-unstyled balance-card simple-list">
            <LI><H3>$18,837</H3></LI>
            <LI className="d-flex justify-content-between"><P>Your Current Balance</P><span>+3,72,900</span></LI>
            <LI className="d-flex justify-content-between"><P>Sent amount</P><span>-25,105</span></LI>
            <LI className="border-desh"></LI>
            <LI className="d-flex justify-content-between"><P>Your Current Balance</P><span>+3,72,900</span></LI>
            <LI>
              <div className="d-flex justify-content-center gap-4">
                <Link className="transfer btn" to={`${process.env.PUBLIC_URL}/ecommerce/checkout`}>{Transfer}</Link>
                <Link className="receive btn" to={`${process.env.PUBLIC_URL}/ecommerce/invoice`}>{Receive}</Link>
              </div>
            </LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default YourCurrentBalance;
